
export default function CreateButton({onClick, className, text}) {
    return (
        <button
            className={`${className} flex flex-row items-center border-b-2 border-playmove-blue font-inter rounded bg-playmove-mediumblue w-28 py-2 hover:bg-playmove-blue`}
            onClick={onClick}><span className="m-auto flex flex-row items-center gap-x-1"><span className="text-sm font-bold text-white ">{text}</span></span></button>
    )
}